import { BaseService, RequestType, ResponseType } from "@intech/react-service";

import { PlanoVinculadoEntidade } from "../entidades/PlanoVinculadoEntidade";
import { PlanoEntidade } from "../entidades/PlanoEntidade";

class Plano extends BaseService {

  constructor() {
    super("Plano");
  }

  Buscar = () =>
    this.CreateRequest<Array<PlanoVinculadoEntidade>>(RequestType.GET, `Buscar`);

  BuscarTodos = () =>
    this.CreateRequest<Array<PlanoEntidade>>(RequestType.GET, `BuscarTodos`);

  BuscarPorCodigo = (cdPlano: string) =>
    this.CreateRequest<Array<PlanoEntidade>>(RequestType.GET, `porCodigo/${cdPlano}`);

  BuscarSaldado = () =>
    this.CreateRequest<PlanoVinculadoEntidade>(RequestType.GET, "saldado");

  RelatorioExtratoPorPlanoReferencia = (cdPlano: string, dtInicio: string, dtFim: string, enviarPorEmail: boolean) =>
    this.CreateRequest<any>(RequestType.GET, `relatorioExtratoPorPlanoReferencia/${cdPlano}/${dtInicio}/${dtFim}/${enviarPorEmail}`, null, ResponseType.Blob);
}

export const PlanoService = new Plano();